import React, { useState, useRef, useMemo, useEffect } from 'react';
import ModalDrawer from './ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import { TRANSLATIONS } from '../../../translations';

const SUCCESS_ICON = 'circleCheck';
const FAIL_ICON = 'warning';

const ModalDrawerResponse = ({
  isOpen,
  setIsOpen,
  isSuccess,
  responseContent,
  modalTitle,
  isDeviceSmallerThanTablet,
}) => {
  return (
    <ModalDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
      modalCustomWidth={640}
      title={modalTitle}
      content={
        <div className="pl-m pr-m pt-xl pb-xl w-100% text-center">
          <div className="d-flex flex-column items-center pb-2xs gap-xs">
            <BetaIcon
              name={isSuccess ? SUCCESS_ICON : FAIL_ICON}
              size={IconSizes[64]}
            />
          </div>
          <div className="d-flex text-center align-center">
            <div
              className="typography__p2 typography__neutral text-center"
              dangerouslySetInnerHTML={{ __html: responseContent }}
            />
          </div>
        </div>
      }
      footer={
        <div className="d-flex justify-center gap-m pb-m pl-xl pr-xl">
          <Button
            classNames={'pr-m pl-m'}
            size={ButtonSizes.s}
            style={ButtonStyles.empty}
            label={<b>{TRANSLATIONS.CLOSE}</b>}
            onClick={() => setIsOpen(false)}
          />
        </div>
      }
    />
  );
};

ModalDrawerResponse.propTypes = {};

export { ModalDrawerResponse };
